import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

export const VideoSectionContainer = styled.section`
  padding: 100px 0;
    @media (max-width: 767px) {
      padding: 50px 0;
    }

  .video_content {
    max-width: 625px;

    h4 {
      color: #021E40;
      font-weight: 600;
    }

    .intro_learnmore {
      padding-top: 15px;
      padding-bottom: 20px;
    }
  }

  .intro-image-wrapper {
    position: relative;
    display: inline-block; width: 100%;
  }

  .intro-image {
    width: 100%;
    border-radius: 0 50px;
  }

  .intro-video{
    width:100%;
    border-radius:0 50px;
  }

  .video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 145px;
    height: auto;
    cursor: pointer;
    filter: drop-shadow(0 0 10px #197f9f);
    animation: glow 2s infinite alternate;
  }

  @keyframes glow {
    from {
      filter: drop-shadow(0 0 10px #197f9f);
    }
    to {
      filter: drop-shadow(0 0 25px rgba(238, 45, 47, 1));
    }
  }


  .intro-image-wrapper iframe {
      width: 100%;
      border-radius: 0 50px;
      min-height: 371px;
  }

  /* Tablet / Desktop */
  @media (max-width: 1199px) {
    .video-icon {
      width: 84px !important;
    }
    .video_content h4 {
      font-size: 29px;
    }
    padding: 50px 0;
  }

  /* Tablet: reverse layout */
  @media (max-width: 991px) {
    .video_content {
      margin-bottom: 20px !important;
    }

    .video_content h2 br {
      display: none;
    }

    .video_content .intro_learnmore {
      padding-bottom: 0;
    }


  }

  @media (max-width: 767px) {
    .video_content {
      max-width: 100%;
      margin-bottom: 25px;
    }
    .video_section_wrappers {
        padding: 50px 0px !important;
    }
    .mygrid-row {
      padding: 50px 0px !important;
    }
    .intro-image-wrapper iframe {
        min-height: 226px;
    }

}

`;
